__turbopack_context__.v({
  "card": "GigAssist-module-sass-module__jPeSYa__card",
  "conclusion": "GigAssist-module-sass-module__jPeSYa__conclusion",
});
